import axios from 'axios';
import { useState, useMemo, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Menu from '../partils/Menu';
import LogoCardapio360 from '../../acets/img_icon/logo192.svg';
import TenancyColor from '../midllers/TenancyColor';
import bgImage from '../../acets/img_site/bglogin.svg';
import ImgWpp from "../../acets/img_icon/wpp.png"

import IconLogo from"../../acets/img_site/novalogo.png"

export default function Login() {
  const navigate = useNavigate();

  const config = useMemo(() => ({
    url: 'api/auth/'
  }), []);

  const tenancylocal = localStorage.getItem('ClienteTenancy');
  const [sucesse, setSucess] = useState(false);
  const [status, setStatus] = useState("");

  const initialValues = {
    email: '',
    senha: ''
  };
  const [values, setValues] = useState(initialValues);
const nivel = localStorage.getItem('usernivel');
  // Observa a variável 'sucesse' para redirecionar após sucesso
 useEffect(() => {
    if (sucesse && nivel != null) {
      navigate(nivel >= 20 ? "/painel" : "/adminpedido");
      window.location.reload();
    }
  }, [sucesse, nivel, navigate]);


  //console.log("aquiii login sem nevel") 
  function onSubmit(ev) {
    ev.preventDefault();
    if (!navigator.onLine) {
      setStatus("❌ Sem conexão com a internet. Verifique sua rede e tente novamente.");
      return false;
    }
   
    if (values.email.trim() === '' || values.senha.trim() === '') {
      alert('ATENÇÃO: Preencha o campo Email e/ou Senha!');
    } else {
      axios.post(config.url, values).then(res => {
        if (res.data?.ERRO === "Nome ou senha incorreto(s)") {
          //alert("Usuário ou senha incorretos");
          setStatus("❌Usuario ou senha incorretos!");
        } else {
          if (res.data.token) {
            localStorage.setItem('keyItemNameg', res.data.token);
            localStorage.setItem('usernivel', res.data.a.nivel);
            const convert = JSON.stringify(res.data.a); 
            localStorage.setItem('ItemUsers', convert);  
            localStorage.setItem('ClienteTenancy', res.data.a.tenancyId); 
            localStorage.setItem('localcolorusers', res.data.a.color);
            console.log(res.data)
            setStatus("Carregando... testeee");
            setSucess(true);  // Define sucesso após definir o token e dados no localStorage
           
          }
        }
      }).catch(
        setStatus("❌Api fora do Ar, entre em contato com a equipe tecnica.")
      );
    }
  }

  function onchenge(ev) {
    const { name, value } = ev.target;
    setValues({ ...values, [name]: value });
  }

  return (
    <div className='w100 row center site-header-img-login h100'>
      <section className='w30 column center b38 h100 cell-none'>
        <div className='w90 column'>
          <img src={IconLogo} alt="logo da empresa" style={{width:'70px', height:'70px'}}/>
          <div className='pcb20'>
            <label className='fs1p5em w100 c3 '>Auto Métricas</label>
          </div>
          
          <label className='c3 fs1p5em pcb20 w100'>Gerencie sua empresa!</label>
          <label className='fs1p3em'>Tenha o controle total do seu negocio! Nosso software simplifica gestão de serviços, estoque e finanças em um só lugar. Mais eficiência, menos dor de cabeça. impulsione seus resultados!</label>
          <p className='pcb50'>Termos de uso</p>       
          <label>Tecnologia Auto Metricas</label>
          <label className='pcb10 fs09em'>Since 2023</label>
        </div>
      </section>

      <section className='h100 w70 cell-tamanho column around b29 ' id='mundando-cor'>
        <div className='w70 h100 b29 cell-tamanho' style={{ background: `url(${bgImage}) no-repeat center/cover`,position:'absolute' }} >
        </div>

        <div className='w40 z15 b2 column center cont-circ8 cell-tamanho90'>
          <h5 className='fb w90 cen c1'>Login</h5>
          <div className=' h40 w80 cont-circ8 column center '>
            <label className='fs1p3em ma10b0 w100 c1'>Que bom ver você! 🤘🎉 {tenancylocal} Pronto para acessar?</label>
            <label className='fs08em c1 w100 ma25b0'>Login apenas para empresas ;D</label>
            <div className="w100">
              <form onSubmit={onSubmit}>
                <label className="w100 c1 fb">Email:</label>
                <input type="text" name="email" onChange={onchenge} placeholder="Ex:joao@gmail.com" style={{color:'#000'}} />
                <label className="w100 c1 fb">Senha:</label>
                <input type="password" name="senha" onChange={onchenge} placeholder="*****" style={{color:'#000'}} />
                {status&&
                  <div className='w100 h5 column center b39'>
                    <label className='c9 cen'>{status}</label>
                  </div>
                }
                <button className='w100 column center h5 ma10b0 pp cont-circ15' type="submit" style={{backgroundColor: TenancyColor().backgroundColor}}>Login</button>
              </form>
            </div>
          </div>
          <label className='fs08em ma10b0 w100 cen c1'>{tenancylocal} - Auto Métricas 2023</label> 
        </div>
      </section>
        <div className="posifixedfim20 rigth20 h10 w10 row end cell-tamanho-metade30">
            <a href="https://api.whatsapp.com/send?phone=5577999152909&text=Olá, quero saber mais sobre o sistema de oficinas ;D" className="w100 row end"><img src={ImgWpp} alt="ok" className="w100 cell-padding4"></img></a>
        </div>
    </div>
  );
}


